import { render } from "./PageGraph.vue?vue&type=template&id=143a7251&scoped=true&ts=true"
import script from "./PageGraph.vue?vue&type=script&lang=ts"
export * from "./PageGraph.vue?vue&type=script&lang=ts"

import "./PageGraph.vue?vue&type=style&index=0&id=143a7251&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143a7251"]])

export default __exports__